module.exports = __webpack_public_path__ + "media/bootstrap-icons/globe2-7ee95559.svg";